import { motion } from 'framer-motion';

const Resume = () => {
    const resumeUrl = 'https://drive.google.com/file/d/1YgyS4eVnPs0azPtxt7bD0DD_uGKGSMlO/view?usp=sharing';

    return (
        <section id="resume" className="section">
            <div className="container">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="mb-12"
                >
                    <div className="flex items-center gap-4 mb-4">
                        <span className="w-12 h-[1px] bg-primary-purple"></span>
                        <span className="text-primary-purple uppercase tracking-widest text-sm font-medium">Resume</span>
                    </div>
                    <h2 className="text-4xl md:text-5xl font-bold">My Resume</h2>
                </motion.div>

                <div className="glass-card p-8 bg-white/[0.02] border border-white/5">
                    <p className="text-gray-300 mb-6">
                        You can view or download my full resume using the link below. It includes education, experience, projects, and certifications.
                    </p>

                    <a
                        href={resumeUrl}
                        target="_blank"
                        rel="noreferrer"
                        className="inline-block bg-primary-purple text-black px-6 py-3 rounded-md font-medium hover:opacity-90"
                    >
                        View / Download Resume
                    </a>
                </div>
            </div>
        </section>
    );
};

export default Resume;
